import { render, staticRenderFns } from "./ForgePolygonViewer.vue?vue&type=template&id=6e8acb5e&scoped=true"
import script from "./ForgePolygonViewer.vue?vue&type=script&lang=js"
export * from "./ForgePolygonViewer.vue?vue&type=script&lang=js"
import style0 from "./ForgePolygonViewer.vue?vue&type=style&index=0&id=6e8acb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8acb5e",
  null
  
)

export default component.exports